import axios from '../plugins/axios'
// const URL = 'http://localhost:5000';
//axios.defaults.headers.common['token'] = 'value' 
//call HID from localstorage

export default class hidServices {
  async getBorangByHID(HID){

    try {
      const res = await axios.get(`${process.env.VUE_APP_API_URL}/public/getBorangByHID?HID=`+HID, {
      })
      console.log(res.data.data)
      return res;
    } catch (error) {
      return error;
    }

  }

  async getDataBLK7(HID){

    try {
      const res = await axios.get(`${process.env.VUE_APP_API_URL}/blk/getDataBLK7?HID=`+HID)
      return res.data.data;
    } catch (error) {
      return error;
    }

  }

  async getBlok7ByHID(HID){

    try {
      const res = await axios.get(`${process.env.VUE_APP_API_URL}/blk/getBlok7ByHID?HID=`+HID)
      return res.data.data;
    } catch (error) {
      return error;
    }

  }
  
  
   


}